module.exports = __webpack_public_path__ + "img/家装-颜料标签.61082ac7.jpg";